/**
 * サーバーステータスAPI サービス
 * サーバー監視APIとの通信を担当
 */

import { apiClient } from '@/shared/lib/axios';
import type { ServerStatusResponse } from '../types/serverStatus.types';

// ===== API エンドポイント =====

const ENDPOINTS = {
  SERVER_STATUS: '/api/server-status',
} as const;

// ===== API関数 =====

/**
 * サーバーステータスを取得
 */
const getServerStatus = async (): Promise<ServerStatusResponse> => {
  const response = await apiClient.get<ServerStatusResponse>(ENDPOINTS.SERVER_STATUS);
  return response.data;
};

// ===== エクスポート =====

export const serverStatusApiService = {
  getServerStatus,
};
